// Posts made by the Super Admin without a business come from the API with `business: null`.
// Every card and detail page reads `item.business.companyName` / `.industry` / `.location`, so a null there
// used to crash the whole page. Instead of guarding ~100 call sites, the API client swaps in this author
// object, so those posts simply show as published by the platform itself.
export const PLATFORM_NAME = "Vartha Business Network"; // change this to rename the "author" shown on admin posts

export const PLATFORM_AUTHOR = Object.freeze({
  id: null,
  slug: null,
  companyName: PLATFORM_NAME,
  industry: "",
  location: "",
  logo: null,
  isPlatform: true, // use `item.business.isPlatform` to hide things that only make sense for a real business
});

/** Walks an API response and replaces every `business: null` with PLATFORM_AUTHOR. Safe on any shape. */
export function withPlatformAuthor(data) {
  if (Array.isArray(data)) return data.map(withPlatformAuthor);
  if (data && typeof data === "object" && Object.getPrototypeOf(data) === Object.prototype) {
    const out = {};
    Object.keys(data).forEach((key) => {
      const value = data[key];
      out[key] = key === "business" && value === null ? PLATFORM_AUTHOR : withPlatformAuthor(value);
    });
    return out;
  }
  return data;
}
